module.exports = __webpack_public_path__ + "img/welcome-banner-tablet.855cfc80.png";